import React from 'react'
import Logo from '../Logo'
import './styles.css'

export default function Footer() {
    return (
        <footer>
            <p>We have a great team of professional cooks</p>
            <Logo />
        </footer>
    )
}
